export default __webpack_public_path__ + "static/alfinaldelcamino-b9f374a6dd892df2e5ade893fc04dec7.jpg";